(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6689],{

/***/ 8249:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations",
      function () {
        return __webpack_require__(74087);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ locations; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/category/LocationRequiredOverlay/index.jsx
var LocationRequiredOverlay = __webpack_require__(76216);
// EXTERNAL MODULE: ./src/components/loader.jsx
var loader = __webpack_require__(67407);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/search/Filters.jsx







var prefixes = {
    services: "providerServices.service.description:",
    brands: "providerLocationBrandMatrix.brand.brandName:",
    categories: "providerLocationBrandMatrix.category.name:"
};
// TODO: Important: Set initial filter UI based on the global store values
var Filters = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Filters, Component);
    var _super = (0,_create_super/* default */.Z)(Filters);
    function Filters(props) {
        (0,_class_call_check/* default */.Z)(this, Filters);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            services: Array(props.services.length),
            brands: Array(props.brands.length),
            categories: Array(props.categories.length)
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(Filters, [
        {
            key: "updateFilters",
            value: function updateFilters(index, value, type) {
                var _this = this;
                // Update the new filter array immutably
                var newFilters = type === "services" ? (0,_to_consumable_array/* default */.Z)(this.state.services) : type === "brands" ? (0,_to_consumable_array/* default */.Z)(this.state.brands) : (0,_to_consumable_array/* default */.Z)(this.state.categories);
                // Toggle the filter value
                // If the new upcoming filter value is invalid, put empty array. Otherwise put new filter value.
                newFilters[index] = !newFilters[index] ? value : "";
                // Replace with new values and update the global store
                // after the state is changed
                if (type === "services") {
                    this.setState({
                        services: newFilters
                    }, function() {
                        _this.props.updateFilters(_this.state);
                    });
                } else if (type === "brands") {
                    this.setState({
                        brands: newFilters
                    }, function() {
                        _this.props.updateFilters(_this.state);
                    });
                } else {
                    this.setState({
                        categories: newFilters
                    }, function() {
                        _this.props.updateFilters(_this.state);
                    });
                }
            }
        },
        {
            // Apply filters from the filters reducer
            key: "synchronize",
            value: function synchronize() {
                var _filters = this.props.filters, brands = _filters.brands, categories = _filters.categories, services = _filters.services;
                var newServices = (0,_to_consumable_array/* default */.Z)(this.state.services);
                var newBrands = (0,_to_consumable_array/* default */.Z)(this.state.brands);
                var newCategories = (0,_to_consumable_array/* default */.Z)(this.state.categories);
                services.forEach(function(element, index) {
                    newServices[index] = element ? element : "";
                });
                brands.forEach(function(element, index) {
                    newBrands[index] = element ? element : "";
                });
                categories.forEach(function(element, index) {
                    newCategories[index] = element ? element : "";
                });
                this.setState({
                    services: newServices,
                    brands: newBrands,
                    categories: newCategories
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.synchronize();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, categories = _props.categories, brands = _props.brands, services = _props.services;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "filters-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "btn",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-bars"
                                            }),
                                            " Services"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden-filters services",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: services.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "btn ".concat(_this.state.services[index] ? "active" : ""),
                                                        onClick: function() {
                                                            return _this.updateFilters(index, "".concat(prefixes.services).concat(item.description), "services");
                                                        },
                                                        children: [
                                                            !_this.state.services[index] && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "far fa-square"
                                                            }),
                                                            _this.state.services[index] && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "far fa-check-square"
                                                            }),
                                                            item.description
                                                        ]
                                                    })
                                                }, item.id);
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "btn",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-bars"
                                            }),
                                            " Brands"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden-filters brands",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: brands.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "btn ".concat(_this.state.brands[index] ? "active" : ""),
                                                        onClick: function() {
                                                            return _this.updateFilters(index, "".concat(prefixes.brands).concat(item.brandName), "brands");
                                                        },
                                                        children: [
                                                            !_this.state.brands[index] && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "far fa-square"
                                                            }),
                                                            _this.state.brands[index] && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "far fa-check-square"
                                                            }),
                                                            item.brandName
                                                        ]
                                                    })
                                                }, item.id);
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "btn",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-bars"
                                            }),
                                            " Categories"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden-filters",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: categories.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "btn ".concat(_this.state.categories[index] ? "active" : ""),
                                                        onClick: function() {
                                                            return _this.updateFilters(index, "".concat(prefixes.categories).concat(item.name), "categories");
                                                        },
                                                        children: [
                                                            !_this.state.categories[index] && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "far fa-square"
                                                            }),
                                                            _this.state.categories[index] && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "far fa-check-square"
                                                            }),
                                                            item.name
                                                        ]
                                                    })
                                                }, item.id);
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return Filters;
}(react.Component);
/* harmony default export */ var search_Filters = (Filters);

// EXTERNAL MODULE: ./src/redux/actions/filters.js
var filters = __webpack_require__(44849);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/locations.jsx
// Optionally Switch to Mapbox/Leaflet   https://www.algolia.com/doc/api-reference/widgets/geo-search/react/?language=component#full-example










var GoogleMap = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(5675), __webpack_require__.e(7727), __webpack_require__.e(9684), __webpack_require__.e(4411), __webpack_require__.e(2190), __webpack_require__.e(5337), __webpack_require__.e(5903)]).then(__webpack_require__.bind(__webpack_require__, 60337));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60337)
            ];
        }
    },
    ssr: false
});
var Locations = function(props) {
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setLoading(false);
        }, 4000);
    }, []);
    var updateFilters = function(value) {
        props.setFilterValue(value);
    };
    var topCategories = props.categories.filter(function(category) {
        return category.includeInTopMenu;
    });
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "page locations",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    title: "Locations | Mobile car and truck battery replacement services at every location",
                    description: "Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support.",
                    canonical: "https://1800battery.com/locations"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "locations-header-alert",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inner",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        children: [
                                            "1800Battery offers mobile car and truck battery replacement services ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "at every location"
                                            }),
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/category/vehicle-batteries-car-or-truck",
                                        as: "/category/vehicle-batteries-car-or-truck",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn book",
                                            children: "Get Started Here"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container mt-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {})
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "page locations",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Locations | Mobile car and truck battery replacement services at every location",
                description: "Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support.",
                canonical: "https://1800battery.com/locations"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "locations-header-alert",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "inner",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    children: [
                                        "1800Battery offers mobile car and truck battery replacement services ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "at every location"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/category/vehicle-batteries-car-or-truck",
                                    as: "/category/vehicle-batteries-car-or-truck",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "btn book",
                                        children: "Get Started Here"
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                style: {
                    position: "relative"
                },
                children: [
                    !props.geolocation.latitude && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationRequiredOverlay/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header-with-filters mt-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search_Filters, {
                            filters: props.filters,
                            categories: topCategories,
                            brands: props.brands,
                            services: props.services,
                            updateFilters: updateFilters
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMap, {
                        filters: props.filters,
                        masterProvider: props.masterProvider,
                        geolocation: props.geolocation
                    })
                ]
            })
        ]
    });
};
var mapDispatchToProps = function(dispatch) {
    return {
        setFilterValue: function(payload) {
            return dispatch(filters/* setFilterValue */.hL(payload));
        }
    };
};
var mapStateToProps = function(state) {
    return {
        geolocation: state.geolocation,
        categories: state.categories.allCategories,
        brands: state.brands.brands,
        services: state.services.services,
        filters: state.filters,
        masterProvider: state.masterProvider
    };
};
/* harmony default export */ var locations = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(Locations));


/***/ }),

/***/ 76216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_home_PlacesSearch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69174);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var LocationRequiredOverlay = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "location-required-overlay on-category",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "inner",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "icon-container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-exclamation-circle"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "content-container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Location Required"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Our products and service availability are dependent on where you are located."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_home_PlacesSearch__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            isModalOpen: false,
                            hasMyLocationButton: true
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LocationRequiredOverlay);


/***/ }),

/***/ 67407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






var Loader = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Loader, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Loader);
    function Loader() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, Loader);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Loader, [
        {
            key: "render",
            value: function render() {
                if (this.props.fullscreen) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                                children: "\n						.circle-loader {\n							position: absolute;\n							top: 50%;\n							left: 50%;\n							width: 50%;\n							z-index: 100;\n							text-align: center;\n							transform: translate(-50%, -50%);\n						}\n\n						.circle-loader .circle {\n							fill: transparent;\n							stroke: rgba(0, 0, 0, 0.5);\n							stroke-width: 4px;\n							animation: dash 2s ease infinite, rotate 2s linear infinite;\n						}\n\n						@keyframes dash {\n							0% {\n								stroke-dasharray: 1, 95;\n								stroke-dashoffset: 0;\n							}\n							50% {\n								stroke-dasharray: 85, 95;\n								stroke-dashoffset: -25;\n							}\n							100% {\n								stroke-dasharray: 85, 95;\n								stroke-dashoffset: -93;\n							}\n						}\n\n						@keyframes rotate {\n							0% {\n								transform: rotate(0deg);\n							}\n							100% {\n								transform: rotate(360deg);\n							}\n						}\n					"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "circle-loader",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "circle",
                                    width: "60",
                                    height: "60",
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                        cx: "30",
                                        cy: "30",
                                        r: "15"
                                    })
                                })
                            })
                        ]
                    });
                } else {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                                children: "\n            .circle-loader {\n              display: block;\n              text-center;\n              padding-left: 50%;\n            }\n\n            .circle-loader .circle {\n              position: relative;\n              left: -30px;\n              fill: transparent;\n              stroke: rgba(0,0,0,0.5);\n              stroke-width: 4px;\n              animation: dash 2s ease infinite, rotate 2s linear infinite;\n            }\n\n            @keyframes dash {\n              0% {\n                stroke-dasharray: 1,95;\n                stroke-dashoffset: 0;\n              }\n              50% {\n                stroke-dasharray: 85,95;\n                stroke-dashoffset: -25;\n              }\n              100% {\n                stroke-dasharray: 85,95;\n                stroke-dashoffset: -93;\n              }\n            }\n\n            @keyframes rotate {\n              0% {transform: rotate(0deg); }\n              100% {transform: rotate(360deg); }\n            }\n          "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "circle-loader",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "circle",
                                    width: "60",
                                    height: "60",
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                        cx: "30",
                                        cy: "30",
                                        r: "15"
                                    })
                                })
                            })
                        ]
                    });
                }
            }
        }
    ]);
    return Loader;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,8214,9174,9774,2888,179], function() { return __webpack_exec__(8249); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);